// Load static fonts
require('./src/styles/fonts.css');
require('./src/styles/tooltip.css');
require('bootstrap/dist/css/bootstrap.min.css')
require('./src/styles/modal.css');

exports.onInitialClientRender = require('./src/gatsby/browser/onInitialClientRender');
exports.onRouteUpdate = require('./src/gatsby/browser/onRouteUpdate');
exports.shouldUpdateScroll = require('./src/gatsby/browser/shouldUpdateScroll');
